module.exports = "<span ng-message=\"required\">{{'errors.required' | i18n}}</span>\n<span ng-message=\"email\">{{'errors.email' | i18n}}</span>\n<span ng-message=\"match\">{{'errors.match' | i18n}}</span>\n<span ng-message=\"pattern\">{{'errors.checkInput' | i18n}}</span>\n<div ng-message=\"minlength\">{{'errors.minlength' | i18n}}</div>\n<div ng-message=\"maxlength\">{{'errors.maxlength' | i18n}}</div>"


//////////////////
// WEBPACK FOOTER
// ./src/ui/app/errors/errors.tpl.html
// module id = 926
// module chunks = 12